import { RECAPTCHA_SITE_KEY, RECAPTCHA_VERIFY_URL } from './recaptcha-config';

declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (
        siteKey: string,
        options: { action: string }
      ) => Promise<string>;
    };
  }
}

export function verifyRecaptcha(enabled: boolean) {
  if (!enabled) {
    return true;
  }

  return new Promise((resolve) => {
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
          action: 'submit'
        });

        const tokenData = new FormData();
        tokenData.append('token', token);

        const response = await fetch(RECAPTCHA_VERIFY_URL, {
          method: 'POST',
          body: tokenData
        });

        if (!response.ok) {
          resolve(false);
        } else {
          resolve(true);
        }
      } catch (error) {
        resolve(false);
      }
    });
  });
}
